export default function TiltifyIcon({ classname = "h-8 w-8" }) {
  return (
    <svg
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width="800"
      height="800"
      version="1"
      viewBox="0 0 600 600"
      className={classname}
      fill="currentColor"
      aria-label="Tiltify Icon"
    >
      <title>Tiltify icon</title>
      <path
        d="M1655 5994c-168-15-274-28-363-45-492-95-900-407-1111-849-87-183-133-352-163-605-19-160-19-2830 0-2990 54-448 192-757 461-1026S1057 72 1505 18c160-19 2830-19 2990 0 448 54 757 192 1026 461s407 578 461 1026c19 160 19 2830 0 2990-54 448-192 757-461 1026-224 223-502 369-818 429-233 43-225 43-1643 45-751 1-1383 1-1405-1zm2900-1036c64-33 129-98 163-163 24-45 27-61 27-155s-3-110-27-155c-34-65-98-129-163-163-45-24-61-27-155-27-91 0-111 3-150 24-61 32-136 106-168 166-24 45-27 60-27 155 0 94 3 110 27 155 45 86 128 157 218 186 14 5 66 7 115 6 74-3 99-8 140-29zm-2584-173c46-8 593-167 1215-354 859-258 1150-349 1211-380 102-51 193-134 230-209 25-50 28-68 28-152 0-88-3-101-33-162-46-94-123-150-249-183-101-26-210-19-585 40-192 30-352 55-354 55s-4-435-4-967c0-560-4-1004-10-1052-20-174-120-315-279-394l-84-42h-254l-84 42c-159 79-259 220-279 394-6 50-10 506-10 1129l1 1045-353 56c-366 59-416 71-511 132-103 66-201 202-233 321-18 69-18 204 2 280 59 229 279 404 520 415 17 0 69-6 115-14z"
        transform="matrix(.1 0 0 -.1 0 600)"
      ></path>
    </svg>
  );
}
